<div t4-tooltip class="t4EntityLink">
    <span class="bookingText"><a href="javascript: void(0)" (mouseenter)="show()" (mouseleave)="hide()" (click)="open()"><span #ref><ng-content></ng-content></span><span *ngIf="ref.childNodes.length == 0">{{ location.Name }}</span></a></span>
    <div #tooltipContent class="t4Tooltip-container">
        <t4-locationInfo [location]="location" *ngIf="location"></t4-locationInfo>
        <div class="t4Tooltip-contentLoader row" *ngIf="!location">
            <mat-spinner indeterminate="true"></mat-spinner>
        </div>
    </div>
</div>
